/*
  Payment price box (COD + Bank Transfer)
  Used by: snippets/payment-price-box.liquid
  Updates every price/saving instantly when the customer changes variant
  (listens to "vc:variant-change" from assets/variant-instant.js).
*/
(function () {
  function makeMoney(fmtStr) {
    return function (cents) {
      cents = Number(cents) || 0;
      var key = (fmtStr.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
      var dec = key.indexOf('no_decimals') > -1 ? 0 : 2;
      var comma = key.indexOf('comma_separator') > -1;
      var parts = (cents / 100).toFixed(dec).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
      var value = whole + (parts[1] ? (comma ? ',' : '.') + parts[1] : '');
      return fmtStr ? fmtStr.replace(/\{\{\s*\w+\s*\}\}/, value) : 'Rs.' + value;
    };
  }

  function currentVariantId() {
    var input = document.querySelector('product-info form[action*="/cart/add"] [name="id"], product-form form [name="id"]');
    return input ? input.value : null;
  }

  function init(root) {
    if (root.dataset.ready) return;
    var dataEl = root.querySelector('[data-pp-variants]');
    if (!dataEl) return;
    root.dataset.ready = '1';

    var prices = JSON.parse(dataEl.textContent);
    var pct = Number(root.dataset.pct) || 5;
    var money = makeMoney(root.dataset.money || '');
    var last = null;

    function set(key, html) {
      root.querySelectorAll('[data-pp="' + key + '"]').forEach(function (n) { n.innerHTML = html; });
    }

    function update(id) {
      var p = prices[String(id)];
      if (!p || String(id) === last) return;
      last = String(id);
      var price = p[0];
      var cmp = p[1];
      var save = cmp > price ? cmp - price : 0;
      var bt = Math.round(price * (100 - pct) / 100 / 100) * 100;
      var extra = price - bt;
      set('now', money(price));
      set('was', money(cmp));
      set('save', money(save));
      set('bt', money(bt));
      set('extra', money(extra));
      set('total', money(save + extra));
      root.querySelectorAll('[data-pp-cmp]').forEach(function (n) { n.hidden = !save; });
    }

    /* Instant: fired on the click itself, before the theme talks to the server */
    document.addEventListener('vc:variant-change', function (e) {
      if (e.detail && e.detail.variant) update(e.detail.variant.id);
    });

    /* Fallbacks (theme events / page variant input) */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        if (e && e.data && e.data.variant) update(e.data.variant.id);
      });
    }
    setInterval(function () { update(currentVariantId()); }, 1500);
  }

  function initAll() { document.querySelectorAll('.pp[data-pct]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
